import React, { useEffect, useState } from 'react';
import './Animation.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWifi } from '@fortawesome/free-solid-svg-icons';

const OfflinePage = () => {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  const refreshPage = () => window.location.reload();

  return (
    <div className="global-loader-overlay">
      <div className="offline-wrapper">
        <FontAwesomeIcon icon={faWifi} className="offline-animation" />
        <h2>Brak połączenia z siecią</h2>
        <p>Sprawdź swoje połączenie i spróbuj ponownie.</p>
        <button className="refresh-btn" onClick={refreshPage}>
          Odśwież stronę
        </button>
      </div>
    </div>
  );
};

export default OfflinePage;
